export enum LogLevel {
  None = 'none',
  Debug = 'debug',
  Info = 'info',
  Warn = 'warn',
  Error = 'error',
}

export type ActiveLogLevel = Exclude<LogLevel, LogLevel.None>;

// reverse map
export const logLevelValues: Record<LogLevel, number> = {
  [LogLevel.None]: 0,
  [LogLevel.Debug]: 1,
  [LogLevel.Info]: 2,
  [LogLevel.Warn]: 3,
  [LogLevel.Error]: 4,
};

export interface NewRelicLoggerConfig {
  licenseKey: string;
  applicationId: string;
  accountId: string;
  trustKey?: string;
  beacon?: string;
  errorBeacon?: string;
  env: string;
  service: string;
  version: string;
}

export type LoggerType = 'console' | 'newrelic';

export type LoggerConfig =
  | { type: 'console'; logLevel: LogLevel }
  | {
      type: 'newrelic';
      logLevel: LogLevel;
      config: NewRelicLoggerConfig;
    };

/**
 * Names of the `console` methods that `LoggerProvider.captureConsoleLogs` can intercept.
 */
export type ConsoleApiName = 'log' | 'debug' | 'info' | 'warn' | 'error';

export type WriteToLog = (
  message: string,
  context?: object,
  error?: Error
) => void;

export interface ILogger {
  name: string;
  createNamedLogger(name: string): ILogger;
  setProjectContext(project?: {
    id: string;
    name: string;
    location: string;
  }): void;
  debug: WriteToLog;
  info: WriteToLog;
  warn: WriteToLog;
  error: WriteToLog;
}
